export function useProductOption() {
    function productPageHref(productOption: any) {
        return `/products/${productOption.product.name.toLowerCase()}`;
    }

    return {
        productPageHref,
    };
}
